import { render, staticRenderFns } from "./shopClassForm.vue?vue&type=template&id=13194120&scoped=true"
import script from "./shopClassForm.vue?vue&type=script&lang=js"
export * from "./shopClassForm.vue?vue&type=script&lang=js"
import style0 from "./shopClassForm.vue?vue&type=style&index=0&id=13194120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13194120",
  null
  
)

export default component.exports